import {getMenu,getMenuEn, getBanner} from "@/api"

const home = {
  state: {
    urlApi: 'https://www.cwmuseum.cn:9021/production',   /////正式发布地址；
    //urlApi: 'http://localhost:8080',
    lang: localStorage.getItem('lang') || 'zh',
    banner: localStorage.getItem('banner') ? JSON.parse(localStorage.getItem('banner')) : [],
    menu: localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : [],
    menuEn: localStorage.getItem('menuEn') ? JSON.parse(localStorage.getItem('menuEn')) : [],
  },
  mutations: {
    SET_LANG: (state, value) => {
      state.lang = value
      localStorage.setItem('lang', value)
    },
    SET_Banner: (state, value) => {
      state.banner = value
      localStorage.setItem('banner', JSON.stringify(value))
    },
    SET_Menu: (state, value) => {
      state.menu = value
      localStorage.setItem('menu', JSON.stringify(value))
    },
    SET_MenuEn: (state, value) => {
      state.menuEn = value
      localStorage.setItem('menuEn', JSON.stringify(value))
    },
  },
  actions: {
    GetLang({commit}, value) {
      commit('SET_LANG', value)
    },
    // 获取内页banner
    // GetBanner({commit, state}) {
    //   return new Promise((resolve, reject) => {
    //     getBanner().then(res => {
    //       console.log('store banner',res)
    //       let {data: {data}} = res
    //       commit('SET_Banner', data)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 获取所有内容的banner
    GetBanner({ commit, state }) {
      return new Promise((resolve, reject) => {
        getBanner({
          pageNum: '1',
          pageSize: '99',
          orderByColumn: "create_time",
          articleClass: state.lang,
          articleType: "轮播图",
          articleKey:'slider',

        }).then(res => {
          let {data:{rows}} = res
          let arr = []
          rows.forEach((val)=>{
            arr.push({
              name: val.articleCode,
              url: state.urlApi + val.faceUrl,
            })
          })
          commit('SET_Banner', arr)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取导航
    GetMenu({commit, state}) {
      return new Promise((resolve, reject) => {
        getMenu().then(res => {
          let {data: {data}} = res
          commit('SET_Menu', data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取导航En
    GetMenuEn({commit, state}) {
      return new Promise((resolve, reject) => {
        getMenuEn().then(res => {
          let {data: {data}} = res
          commit('SET_MenuEn', data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default home



// WEBPACK FOOTER //
// ./src/store/modules/home.js